import { ModalIOF } from '@old/ui/modal/modal';
import i18n from '../../../libs/language';
import { useService } from '@old/hooks/use-service';
import { Stack, Typography, Button, Box, IconButton } from '@mui/material';
import { BaseTable } from '@old/ui/table';
import { GridColDef } from '@mui/x-data-grid-pro';
import Download from '@old/assets/svg/donwload-new.svg';
import { getReportSatViewService } from '@old/services/domain/silosat/get-report-sat';
import { getReportSatViewByIdService } from '@old/services/domain/silosat/get-pdf-report-sat';
import ReloadIcon from '@old/assets/svg/SiloBagPage/view/reload.svg';
import { useState } from 'react';
import { downloadBlob } from '@old/utils/export-files';
import { useEffectOnUpdate } from '@old/hooks/core';
import dayjs from 'dayjs';

type dataReportSat = Awaited<ReturnType<typeof getReportSatViewService>>['summary']['response']['results'];

type CMCModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  isLoadingPost?: boolean;
  isSuccessPost?: boolean;
};

export const ReportSatelitalModal = ({ open, setOpen, isLoadingPost }: CMCModalProps) => {
  const [currentGeneratedAt, setCurrentGeneratedAt] = useState('');

  const {
    summary,
    isLoading: isLoadingGet,
    trigger,
  } = useService(getReportSatViewService, { fetchOnMount: true });

  const {
    trigger: triggerPdfDownload,
    isSuccess: isSuccessPdf,
    summary: pdfSummary,
  } = useService(getReportSatViewByIdService);

  const handleMenuClose = () => {
    setOpen(false);
  };

  useEffectOnUpdate(() => {
    if (isSuccessPdf) {
      downloadBlob(pdfSummary as Blob, currentGeneratedAt, i18n.t('app.certification_sat.pdfName'));
    }
  }, [isSuccessPdf]);

  const columns: GridColDef<dataReportSat[0]>[] = [
    {
      field: 'generatedAt',
      headerName: i18n.t('app.date'),
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      renderCell: ({ value }) => {
        const date = dayjs(value);
        return <div>{date.isValid() ? date.format('DD/MM/YYYY HH:mm') : ''}</div>;
      },
    },

    { field: 'status', headerName: 'Estado', flex: 1, headerAlign: 'center', align: 'center' },
    {
      field: 'action',
      headerName: i18n.t('app.actions'),
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => {
        const id = params.row.id;
        const generatedAt = params.row.generatedAt;
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
            <IconButton
              sx={{
                color: 'info.main',
                padding: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '&:hover': { backgroundColor: 'transparent' },
              }}
              onClick={() => {
                setCurrentGeneratedAt(generatedAt);
                triggerPdfDownload({ query: id });
              }}
            >
              <img
                src={Download}
                alt="download"
                style={{
                  display: 'block',
                  margin: 'auto',
                }}
              />
            </IconButton>
          </Box>
        );
      },
    },
  ];

  return (
    <ModalIOF open={open} ModalIsOpen={setOpen}>
      <ModalIOF.Header>
        <Typography variant="h5" fontWeight={500} component="div" sx={{ margin: '20px' }}>
          {i18n.t('app.certification_sat.report_sat_certification')}
        </Typography>
        <Button
          startIcon={<img src={ReloadIcon} style={{ width: 16, height: 13 }} />}
          variant="text"
          sx={{ color: 'info.main', textTransform: 'none', fontWeight: 600 }}
          onClick={() => trigger()}
        >
          {i18n.t('app.silobag_detail.refresh')}
        </Button>
      </ModalIOF.Header>
      <Stack direction={'row'} spacing={1}></Stack>
      <ModalIOF.Body>
        <BaseTable
          columns={columns}
          rows={summary?.response?.results ?? []}
          loading={isLoadingGet || isLoadingPost}
          initialPageSize={5}
          noInternalBorders
        />
        <Stack direction={'row'} justifyContent={'flex-end'}>
          <Button size="medium" onClick={handleMenuClose}>
            {i18n.t('app.close')}
          </Button>
        </Stack>
      </ModalIOF.Body>
    </ModalIOF>
  );
};
